/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PointsTransactionsHistoryListPostRequest } from '../models/PointsTransactionsHistoryListPostRequest';
import type { TransactionsHistoryResponse } from '../models/TransactionsHistoryResponse';
import { request as __request } from '../core/request';

export class PointsService {

    /**
     * @param requestBody
     * @returns TransactionsHistoryResponse Ok
     * @throws ApiError
     */
    public static async getPointsTransactionList(
        requestBody?: PointsTransactionsHistoryListPostRequest,
    ): Promise<TransactionsHistoryResponse> {
        const result = await __request({
            method: 'POST',
            path: `/points/list`,
            body: requestBody,
            errors: {
                400: `Validation Failed`,
                403: `Forbidden`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

    /**
     * @returns string Ok
     * @throws ApiError
     */
    public static async getPoints(): Promise<string> {
        const result = await __request({
            method: 'GET',
            path: `/points/checkPoints`,
            errors: {
                403: `Forbidden`,
                500: `Internal Server Error`,
                503: `External Server Error`,
            },
        });
        return result.body;
    }

}